import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// import { i18n } from './i18n/index'
// import VueCopy from 'v-copy'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import 'animate.css'

import mixin from './mixins/mixin'

import http from '@/utils/request'

Vue.prototype.$http=http

// Vue.use(VueCopy)
Vue.use(ElementUI)

Vue.mixin(mixin)
Vue.config.productionTip = false
import './utils/rem';

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App)
}).$mount('#app')
